<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="snackbarColor"
    auto-height
    :timeout="snackbarTimeout"
    :multi-line="true"
    :z-index="999999"
    location="top right"
  >
    <v-layout align-center pr-4 class="flex width">
      <v-icon class="pr-3" size="34"> {{ snackbarIcon }} </v-icon>
      <v-layout class="flex collumn">
        <div>
          <strong>{{ snackbarTitle }}</strong>
        </div>
        <div>{{ snackbarMessage }}</div>
      </v-layout>
      <v-icon @click="showSnackbar = false" size="20">mdi-close</v-icon>
    </v-layout>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      showSnackbar: false,
      snackbarTimeout: 3000,
      snackbarColor: null,
      snackbarMessage: null,
      snackbarIcon: null,
      snackbarTitle: null,
    };
  },
  methods: {
    showSuccessSnackbar(title, message) {
      this.showSnackbar = true;
      this.snackbarColor = 'success';
      this.snackbarTitle = title;
      this.snackbarMessage = message;
      this.snackbarIcon = 'mdi-check-circle-outline';
    },
    showErrorSnackbar(title, message) {
      this.showSnackbar = true;
      this.snackbarColor = 'error';
      this.snackbarTitle = title;
      this.snackbarMessage = message;
      this.snackbarIcon = 'mdi-alert-circle-outline';
    },
    showInfoSnackbar(title, message) {
      this.showSnackbar = true;
      this.snackbarColor = 'info';
      this.snackbarTitle = title;
      this.snackbarMessage = message;
      this.snackbarIcon = 'mdi-information-outline';
    },
    showWarningSnackbar(title, message) {
      this.showSnackbar = true;
      this.snackbarColor = 'warning';
      this.snackbarTitle = title;
      this.snackbarMessage = message;
      this.snackbarIcon = 'mdi-alert-outline';
    },
  },
};
</script>

<style scoped>
.snackbar {
  max-width: 400px;
}
.flex {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  padding: 5px;
}
.collumn {
  flex-direction: column;
  align-items: flex-start;
}
.width {
  max-width: 360px;
}
</style>
